import {useQuery} from '@tanstack/react-query'
import {getCompaniesHttp} from 'src/layouts/main-layout/companies-selector/http/get-companies.http'

export function useCompanies() {
  return useQuery({refetchOnMount: 'always', queryFn: getCompaniesHttp, queryKey: ['list']})
}
